<div class="w-full max-w-md">
  <!-- <ng-container *ngFor="let pMethod of paymentMethods">
    <label
      class="flex items-center border p-4 mb-4 rounded-lg cursor-pointer transition-transform duration-300 ease-in-out transform hover:scale-105"
      (click)="onTicketChange(pMethod)"
      [ngClass]="{ 'border-black border-2': selectedPaymentMethod === pMethod }"
    >
      <input
        type="radio"
        name="ticketType"
        [value]="pMethod"
        class="mr-3 h-5 w-5 text-black"
        [checked]="selectedPaymentMethod === pMethod"
      />

      <div class="flex-1">
        <img *ngIf="pMethod.imageUrl &&(pMethod.imageUrl !== '')" [src]="pMethod.imageUrl" class="h-8" alt="payment method" />

        
        <span class="text-sm text-gray-400">
            {{pMethod.label}}
          </span>
      </div>
    </label>
  </ng-container> -->
</div>
